/**
 * Asynchronously loads the component for NurturingCandidatesPage
 */

import { lazyLoad } from 'utils/loadable';

export const NurturingCandidatesPage = lazyLoad(
  () => import('./index'),
  module => module.NurturingCandidatesPage,
);
